export default __webpack_public_path__ + "static/media/image1.14dbb2cd.svg";